import script from "./SignalDot.vue?vue&type=script&setup=true&lang=js"
export * from "./SignalDot.vue?vue&type=script&setup=true&lang=js"

import "./SignalDot.vue?vue&type=style&index=0&id=a0e4588a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2_postcss@8.5.31_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0e4588a"]])

export default __exports__